var map = {
	"./icon-0.png": 1254,
	"./icon-1.png": 2022,
	"./icon-2.png": 3111,
	"./icon-3.png": 3035,
	"./icon-4.png": 8296,
	"./icon-5.png": 6934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7012;